import { Timestamp } from "@bufbuild/protobuf";

import {
  GetOrganizationRestrictionConfigurationAsAdminRequest,
  GetOrganizationRestrictionConfigurationAsAdminResponse,
  GetOrganizationRestrictionsRequest,
  GetOrganizationRestrictionsResponse,
  GetUserRestrictionsAsAdminRequest,
  GetUserRestrictionsAsAdminResponse,
  ListOrgUserRestrictionsAsAdminRequest,
  ListOrgUserRestrictionsAsAdminResponse,
} from "@safetyculture/s12-apis-connect-web/s12/restrictions/admin/v1/restrictions_pb";
import {
  RestrictionName,
  SortDirection,
} from "@safetyculture/s12-apis-connect-web/s12/restrictions/v1/common_pb";

import { supportServiceConnectClient } from "../index";
import { RequestMetadata } from "api/types";

type GetUserRestrictionsParams = {
  userId: string;
  restrictionNames: string[];
};

export const getUserRestrictions = async (
  { userId, restrictionNames }: GetUserRestrictionsParams,
  headers: Record<RequestMetadata, string>
): Promise<GetUserRestrictionsAsAdminResponse> => {
  const req = new GetUserRestrictionsAsAdminRequest({
    userId,
    restrictionNames,
  });

  return supportServiceConnectClient.getUserRestrictions(req, { headers });
};

type GetOrgRestrictionsParams = {
  organizationId: string;
  restrictionNames: string[];
};

export const getOrgRestrictions = async (
  { organizationId, restrictionNames }: GetOrgRestrictionsParams,
  headers: Record<RequestMetadata, string>
): Promise<GetOrganizationRestrictionsResponse> => {
  const req = new GetOrganizationRestrictionsRequest({
    organizationId,
    restrictionNames,
  });

  return supportServiceConnectClient.getOrgRestrictions(req, { headers });
};

type GetOrgRestrictionConfigurationParams = {
  organizationId: string;
  restrictionName: RestrictionName;
};

export const getOrgRestrictionConfiguration = async (
  { organizationId, restrictionName }: GetOrgRestrictionConfigurationParams,
  headers: Record<RequestMetadata, string>
): Promise<GetOrganizationRestrictionConfigurationAsAdminResponse> => {
  const req = new GetOrganizationRestrictionConfigurationAsAdminRequest({
    organizationId,
    restrictionName,
  });

  return supportServiceConnectClient.getOrgRestrictionConfiguration(req, {
    headers,
  });
};

type ListOrgUserRestrictionsParams = {
  organizationId: string;
  restrictionName: RestrictionName;
  sortBy?: string;
  sortDirection?: SortDirection;
  pageNumber?: number;
  pageSize?: number;
  fromTime?: Date;
  toTime?: Date;
};

export const listOrgUserRestrictions = async (
  {
    organizationId,
    restrictionName,
    sortBy,
    sortDirection,
    pageNumber,
    pageSize,
    fromTime,
    toTime,
  }: ListOrgUserRestrictionsParams,
  headers: Record<RequestMetadata, string>
): Promise<ListOrgUserRestrictionsAsAdminResponse> => {
  const req = new ListOrgUserRestrictionsAsAdminRequest({
    organizationId,
    restrictionName,
    sortBy,
    sortDirection,
    pageNumber,
    pageSize,
    fromTime: fromTime ? Timestamp.fromDate(fromTime) : undefined,
    toTime: toTime ? Timestamp.fromDate(toTime) : undefined,
  });

  return supportServiceConnectClient.listOrgUserRestrictions(req, { headers });
};
